import React, { useEffect } from 'react';

/**
 * Loads EZ Texting signup form assets. Only mount this on pages that display
 * the EZ Texting "Join our text list!" form to avoid render-blocking on other pages.
 */
const EzTextingLoader = () => {
  useEffect(() => {
    const existingValidation = document.querySelector(
      'script[src*="signup-forms-validation"]'
    );
    if (existingValidation) {
      return;
    }

    const script = document.createElement('script');
    script.src =
      'https://cdn.eztexting.com/assets/signup-forms/signup-forms-validation.min.js';
    script.async = true;
    document.body.appendChild(script);

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      'https://cdn.eztexting.com/assets/signup-forms/signup-forms-styles.min.css';
    document.head.appendChild(link);

    return () => {
      script.remove();
      link.remove();
    };
  }, []);

  return null;
};

export default EzTextingLoader;
